import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";

const trustpilotReviews = [
  {
    name: "Tony",
    initial: "T ",
    time: "7 months ago",
    review:
      "I was having problems with my computer always going slow, switching it self on and off so it was time to find someone who was capable of fixing the problem. A neighbour told me about someone that could help and he supplied the name and phone number of the person, l phoned and it wasn't long after that he came and got started, l was informed that l needed a new disk so I ...",
  },
  {
    name: "Samuel",
    initial: "S",
    time: "6 months ago",
    review:
      "They are very Professional, knowledgeable, and always available when needed. R2 makes IT support simple and stress-free. Exactly what every business needs.",
  },
  {
    name: "Rumbidzai Mukarakate",
    initial: "R",
    time: "7 months ago",
    review:
      "Fast response times, excellent communication, and real results. Our systems have never been more stable. R2 System Solution Ltd is worth every penny.",
  },
  {
    name: "Elizabeth D Omosebi",
    initial: "E",
    time: "6 months ago",
    review:
      "Top notch website builder. Am impressed. Very prompt and always wanting to hear you out. I will recommend to anyone who wants a website built for them.",
  },
];

export default function TrustpilotReviewsSection() {
  const [index, setIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const cardsPerView = 3;
  const maxIndex = trustpilotReviews.length - cardsPerView;

  useEffect(() => {
    if (isHovered) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, [isHovered, maxIndex]);

  const next = () => {
    setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };

  const prev = () => {
    setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  return (
    <div className="bg-white py-16 px-6">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-10">
        {/* LEFT SIDE */}
        <div className="lg:w-1/3">
          <h2 className="text-xl font-semibold mb-2">
            R2 System Solution - Rated on Trustpilot
          </h2>

          <div className="flex items-center gap-2 mb-2">
            <span className="text-green-600 font-semibold text-lg">4.9</span>
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <div key={i} className="w-4 h-4 bg-green-600" />
              ))}
            </div>
          </div>

          {/* <p className="text-gray-600 text-sm mb-1">Based on 120 reviews</p> */}

          <p className="text-gray-500 text-sm mb-4">
            powered by{" "}
            <span className="text-green-600 font-semibold">Trustpilot</span>
          </p>

          <a
            href="https://www.trustpilot.com/review/r2systemsolution.co.uk"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-600 text-white px-5 py-2 rounded-full hover:bg-green-700 transition"
          >
            Review us on Trustpilot
          </a>
        </div>

        {/* RIGHT SIDE SLIDER */}
        <div
          className="lg:w-2/3 relative overflow-hidden"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <motion.div
            className="flex gap-6"
            animate={{ x: `-${index * (100 / cardsPerView)}%` }}
            transition={{ type: "spring", stiffness: 120, damping: 20 }}
          >
            {trustpilotReviews.map((review, i) => (
              <div
                key={i}
                className="min-w-[100%] md:min-w-[calc(100%/3-16px)] bg-gray-50 p-6 rounded-lg shadow-md hover:shadow-lg transition"
              >
                {/* Header */}
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-green-600 text-white flex items-center justify-center font-semibold">
                    {review.initial}
                  </div>
                  <div>
                    <p className="font-semibold text-sm">{review.name}</p>
                    <p className="text-xs text-gray-500">{review.time}</p>
                  </div>
                </div>

                {/* Stars */}
                <div className="flex gap-1 mb-3">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="w-4 h-4 bg-green-600" />
                  ))}
                </div>

                {/* Review */}
                <p className="text-sm text-gray-700">{review.review}</p>
              </div>
            ))}
          </motion.div>

          {/* Arrows */}
          <button
            onClick={prev}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full hover:shadow-lg transition"
          >
            <ChevronLeft size={18} />
          </button>

          <button
            onClick={next}
            className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-md p-2 rounded-full hover:shadow-lg transition"
          >
            <ChevronRight size={18} />
          </button>

          {/* Dots */}
          <div className="flex justify-center mt-6 gap-2">
            {Array.from({ length: maxIndex + 1 }).map((_, i) => (
              <div
                key={i}
                onClick={() => setIndex(i)}
                className={`h-2 w-2 rounded-full cursor-pointer transition-all ${
                  i === index ? "bg-green-600 w-4" : "bg-gray-300"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
